// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__1VIIW","noScroll":"modal_noScroll__3PS_Z","mobilesafari":"modal_mobilesafari__AMZxN"};